const favPlaces = [
  {
    id: 1,
    name: "Горы",
    address: "Дагестан, Село Карата",
    lat: 42.595806,
    lon: 46.335875,
    whose_id: 2,
  },
  {
    id: 2,
    name: "Море",
    address: "Каспийское море",
    lat: 41.874063,
    lon: 50.729036,
    whose_id: 2,
  },
  {
    id: 3,
    name: "Баскетбольная площадка",
    address: "Москва, Фестивальный парк",
    lat: 55.792496,
    lon: 37.619442,
    whose_id: 2,
  },

  {
    id: 4,
    name: "Лодочная станция на Шибаевском пруду",
    address: "Москва, Шибаевский пруд",
    lat: 55.692142,
    lon: 37.775210,
    whose_id: 1,
  },
  {
    id: 5,
    name: "Строгино",
    address: "Строгинское ш., 3",
    lat: 55.802948,
    lon: 37.430399,
    whose_id: 1,
  },
  {
    id: 6,
    name: "Центральный академический театр Российской Армии",
    address: "Суворовская площадь, 2",
    lat: 55.782795,
    lon: 37.613808,
    whose_id: 1,
  },

  {
    id: 7,
    name: "Парк",
    address: "Нижегородская область, Саров, улица Зернова",
    lat: 54.938015,
    lon: 43.329320,
    whose_id: 3,
  },
  {
    id: 8,
    name: "Саровская ривьера",
    address: "просп. Музрукова, 13, корп. 1-11, Саров",
    lat: 54.929948,
    lon: 43.322189,
    whose_id: 3,
  },
  {
    id: 9,
    name: "пруд Протяжное",
    address: "Саров, Нижегородская область",
    lat: 54.873714,
    lon: 43.448133,
    whose_id: 3,
  },

  {
    id: 10,
    name: "деревня Поварня",
    address: "Свердловская область, деревня Поварня",
    lat: 56.707703,
    lon: 60.988727,
    whose_id: 4,
  },
  {
    id: 11,
    name: "Ельцин центр",
    address: "Екатеринбург, Ельцин центр",
    lat: 56.844894,
    lon: 60.591438,
    whose_id: 4,
  },
  {
    id: 12,
    name: "парк зеленая роща",
    address: "Екатеринбург, парк зеленая роща",
    lat: 56.822373,
    lon: 60.594614,
    whose_id: 4,
  },
];

export default favPlaces;
